export function assertIsDefined(v: unknown, message?: string): asserts v {
  if (v === undefined || v === null) {
    throw new Error(message ?? `Unexpected ${v} value`);
  }
}
